import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { AppConfigLoader } from '../../config/app-config.loader';

import { BrowserService } from './browser.service';

@Injectable({
  providedIn: 'root',
})
export class SupportLinksService {
  // services
  private readonly translocoService = inject(TranslocoService);
  private readonly browserService = inject(BrowserService);
  private readonly appConfigLoader = inject(AppConfigLoader);

  async openFaq$(): Promise<void> {
    const { faqUrl } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(faqUrl[lang as keyof typeof faqUrl] ?? faqUrl.fallback);
  }

  async openContactSupport$(): Promise<void> {
    const { contactSupportUrl } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(contactSupportUrl[lang as keyof typeof contactSupportUrl] ?? contactSupportUrl.fallback);
  }

  async openAddCreditsSite$(): Promise<void> {
    const { buyCreditsUrl } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(buyCreditsUrl[lang as keyof typeof buyCreditsUrl] ?? buyCreditsUrl.fallback);
  }

  async openBilling$(): Promise<void> {
    const { billingUrl: billing } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(billing[lang as keyof typeof billing] ?? billing.fallback);
  }

  async openInvoices$(): Promise<void> {
    const { invoiceUrl } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(invoiceUrl[lang as keyof typeof invoiceUrl] ?? invoiceUrl.fallback);
  }
}
